import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/shared/wrappers/Layout'
import { UserProfile } from '@/features/user-profile/views'
import {
  getUserControllerGetMeQueryKey,
  userControllerGetMe,
  useUserControllerGetMe,
} from '@/api/users/users'
import CoinAnimation from '@/ui/loader'
import {
  getProfilesControllerGetUserProfileQueryKey,
  profilesControllerGetUserProfile,
} from '@/api/profiles/profiles'
import { client } from '@/features/query/client'
import { UserDto } from '@/api/model'

export const Route = createFileRoute('/profile/$id')({
  component: RouteComponent,
  loader: async () => {
    return Promise.allSettled([
      client
        .fetchQuery({
          queryKey: getUserControllerGetMeQueryKey(),
          queryFn: () => userControllerGetMe(),
        })
        .then((data: UserDto) => {
          if (!data) return

          return client.prefetchQuery({
            queryKey: getProfilesControllerGetUserProfileQueryKey(data.id),
            queryFn: () => profilesControllerGetUserProfile(data.id),
          })
        }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data } = useUserControllerGetMe()

  const isOwnProfile = id === data?.id

  return (
    <Layout>
      <UserProfile id={id} isOwnProfile={isOwnProfile} />
    </Layout>
  )
}
